import React from "react";
import { HeaderType } from "../../vars";
import DefaultHeader from "../defaultHeader/DefaultHeader";
import IdntfyHeader from "../idntfyHeader/IdntfyHeader";

function Header({ whatTypeHeader, ...props }) {
	switch (whatTypeHeader) {
		case HeaderType.IdntfyStore:
			return <IdntfyHeader {...props} />;
		case HeaderType.Deafult:
			return <DefaultHeader {...props} />;
		default:
			return null;
	}
}

export default Header;
